<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

addEventListener("DOMContentLoaded", () => {
  const collDescDiv = document.querySelector(".articleLookbook-item .articleLookbook-des");
  const collReadmore = document.querySelector(".articleLookbook-item .read-more");

  if (!collDescDiv || !collReadmore) return;

  const hasOverflow = collDescDiv.scrollHeight > collDescDiv.clientHeight + 2;

  if (hasOverflow) {
    collReadmore.style.display = "block";

    collReadmore.addEventListener("click", function (e) {
      e.preventDefault();
      collDescDiv.classList.toggle("open");
      collReadmore.classList.toggle("open");
    });
  } else {
    collReadmore.style.display = "none";
  }
});

